import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shell } from "@/components/Shell";

export function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Shell><p className="eyebrow mt-10" data-testid="auth-loading">Loading…</p></Shell>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
